import React, {
    ReactElement, useState,
    useEffect,
} from "react";
import {
    Dropdown,
} from "react-bootstrap";
import { toInputDate } from "../../../date";

export interface DateRangeProps {
    startDate?: Date;
    endDate?: Date;
    onChange: (startDate: Date | undefined, endDate: Date | undefined) => void;
}

export default function DateRangeFilter(props: DateRangeProps): ReactElement {
    const [isDisplayDate, setIsDisplayDate] = useState(false);
    const [startDate, setStartDate] = useState<string>();
    const [endDate, setEndDate] = useState<string>();

    useEffect(() => {
        setStartDate(props.startDate ? toInputDate(props.startDate) : "");
        setStartDate(props.endDate ? toInputDate(props.endDate) : "");
    }, [props.startDate, props.endDate]);

    useEffect(() => {
        if ((!props.startDate || startDate !== toInputDate(props.startDate))
            || (!props.endDate || endDate !== toInputDate(props.endDate))) {
            props.onChange(startDate ? new Date(startDate) : undefined, endDate ? new Date(endDate) : undefined);
        }
    }, [startDate, endDate]);

    const today = new Date();
    const maxDate = toInputDate(today);

    return (

        <Dropdown
            className="p-0 m-0 text-light"
            show={isDisplayDate}
            onToggle={() => setIsDisplayDate(curr => !curr)}
        >
            <Dropdown.Toggle variant="none" className="text-light-400 p-0 me-3">
                <small>
                    Created
                    {!startDate && !endDate && " Date"}
                    {startDate && !endDate && " after "}
                    {startDate && endDate && " between "}
                    {startDate ? new Date(startDate).toLocaleDateString() : ""}
                    {startDate && endDate && " and "}
                    {!startDate && endDate && " before "}
                    {endDate ? new Date(endDate).toLocaleDateString() : ""}
                </small>
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <form
                    className="p-2 py-1"
                    onSubmit={evt => {
                        evt.preventDefault();
                        setIsDisplayDate(false);
                    }}
                >
                    <h6 className="mb-3">Filter by Created Date</h6>

                    <label className="mb-2 w-100">
                        <span className="mb-1">Start Date</span>
                        <input
                            type="date"
                            className="form-control w-100"
                            onChange={evt => setStartDate(evt.target.value)}
                            max={endDate || maxDate}
                        />
                    </label>

                    <label className="mb-2 w-100">
                        <span className="mb-1">End Date</span>
                        <input
                            type="date"
                            className="form-control w-100"
                            onChange={evt => setEndDate(evt.target.value)}
                            min={startDate}
                            max={maxDate}
                        />
                    </label>

                    <div className="d-flex justify-content-between">
                        <button
                            type="button"
                            className="btn btn-none text-danger btn-sm p-2 mt-2"
                            onClick={() => {
                                setStartDate("");
                                setEndDate("");
                                setIsDisplayDate(false);
                            }}
                        >
                            Reset
                        </button>

                    </div>
                </form>

            </Dropdown.Menu>
        </Dropdown>

    );
}

DateRangeFilter.defaultProps = {
    startDate: undefined,
    endDate: undefined,
};
